import { supabase } from '@/lib/supabase';

// ─────────────────────────────────────────────────────────────
// notifyPush — déclenche l'envoi d'une notification Web Push vers tous
// les appareils d'un utilisateur. Appelé juste après la création d'une
// notification, pour que l'alerte atteigne le téléphone même application
// fermée.
//
// BEST-EFFORT : l'échec du push ne doit jamais faire échouer l'action
// métier (commande, message, mouvement de stock…).
// ─────────────────────────────────────────────────────────────

export interface PushPayload {
  title?: string;
  body?: string;
  tag?: string;
  url?: string;
  /** Type métier (order/message/booking…) : permet au serveur de déduire la
   *  page cible même si `url` n'est pas fourni. */
  type?: string;
}

export async function triggerPushForUser(
  userId: number | string | null | undefined,
  payload?: PushPayload,
): Promise<void> {
  const uid = Number(userId);
  if (!Number.isFinite(uid) || uid <= 0) return;
  const body: Record<string, unknown> = { action: 'notify', userId: uid };
  if (payload?.title) body.title = payload.title;
  if (payload?.body) body.body = payload.body;
  if (payload?.tag) body.tag = payload.tag;
  if (payload?.url) body.url = payload.url;
  if (payload?.type) body.type = payload.type;
  try {
    await supabase.functions.invoke('send-push', { body });
  } catch {
    /* best-effort */
  }
}

/**
 * Annonce « un live ZCall vient de démarrer » à TOUS les abonnés push
 * (Web Push natif + OneSignal). Déclenché quand l'hôte lance une diffusion
 * en direct. Best-effort : n'échoue jamais l'action métier.
 */
export async function triggerLivePush(title: string, roomId: string): Promise<void> {
  const basePath = (typeof __BASE_PATH__ !== 'undefined' ? __BASE_PATH__ : '').replace(/\/$/, '');
  const url = `${window.location.origin}${basePath}/zcall/${roomId}`;
  try {
    await supabase.functions.invoke('send-push', {
      body: {
        action: 'broadcast-live',
        title: 'Live ZCall en direct',
        body: `${title || 'Une diffusion'} vient de commencer. Rejoignez le live !`,
        url,
        tag: `zcall-live-${roomId}`,
      },
    });
  } catch {
    /* best-effort */
  }
}